/** Live speed: sim seconds per 1 wall second. */
export function resolveSimSpeed(simSpeed: unknown): number {
  return typeof simSpeed === 'number' && Number.isFinite(simSpeed) && simSpeed > 0 ? simSpeed : 1;
}

/** Convert a `*WallSec` stream knob into sim seconds (`wallSec * simSpeed`). */
export function wallSecToSimSec(wallSec: number, simSpeed: unknown): number {
  return wallSec * resolveSimSpeed(simSpeed);
}

export function simSecToWallSec(simSec: number, simSpeed: unknown): number {
  return simSec / resolveSimSpeed(simSpeed);
}
